import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import {
  Settings as FieldsIcon,
  Monitor as MonitorIcon,
  Assessment as ThresholdsIcon,
  ShowChart as LineIcon
} from '@mui/icons-material';

import FieldManagement from '../FieldManagement/FieldManagement';
import DataManagement from '../DataManagement/DataManagement';
import ThresholdManagement from '../ThresholdManagement/ThresholdManagement';
import MonitorDataReport from '../ReportsManagement/MonitorDataReport';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`data-management-tabpanel-${index}`}
      aria-labelledby={`data-management-tab-${index}`}
      {...other}
    >
      <Box sx={{ pt: 2, display: value === index ? 'block' : 'none' }}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `data-management-tab-${index}`,
    'aria-controls': `data-management-tabpanel-${index}`,
  };
}

const DataManagementTabs: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ mt: -4 }}>
      {/* Sub-navigation for Data Management */}
      <Paper 
        elevation={0}
        sx={{ 
          mb: 2,
          backgroundColor: '#f5f5f5'
        }}
      >
        <Box sx={{ px: 2, pt: 0.5 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="data management tabs"
            sx={{
              minHeight: 40,
              '& .MuiTab-root': {
                minHeight: 40,
                textTransform: 'none',
                fontSize: '0.8125rem',
                fontWeight: 500,
                minWidth: 100,
                padding: '6px 12px'
              },
              '& .MuiTab-iconWrapper': {
                fontSize: '1rem'
              }
            }}
          >
            <Tab
              icon={<MonitorIcon />}
              label="Monitor"
              {...a11yProps(0)}
            />
            <Tab
              icon={<LineIcon />}
              label="Monitor Report"
              {...a11yProps(1)}
            />
            <Tab
              icon={<FieldsIcon />}
              label="Fields"
              {...a11yProps(2)}
            />
            <Tab
              icon={<ThresholdsIcon />}
              label="Thresholds"
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} />
      </Paper>

      {/* Tab Content - All components render immediately for background loading */}
      <TabPanel value={tabValue} index={0}>
        <DataManagement />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <MonitorDataReport />
      </TabPanel>
      
      <TabPanel value={tabValue} index={2}>
        <FieldManagement />
      </TabPanel>
      
      <TabPanel value={tabValue} index={3}>
        <ThresholdManagement />
      </TabPanel>
    </Box>
  );
};

export default DataManagementTabs;
